"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateListsInLists = exports.updateListInListsWithoutSorting = exports.updateListInLists = void 0;
var _sortLists = require("./sortLists");
/**
 * Updates a list in the lists array.
 */
const updateListInListsWithoutSorting = ({
  list,
  lists
}) => {
  const index = lists.findIndex(listItem => listItem.id === list.id);
  if (index === -1) {
    return [...lists, list];
  }
  return [...lists.slice(0, index), list, ...lists.slice(index + 1)];
};

/**
 * Updates a list in the lists array and sorts the lists.
 */
exports.updateListInListsWithoutSorting = updateListInListsWithoutSorting;
const updateListInLists = ({
  list,
  lists
}) => (0, _sortLists.sortLists)(updateListInListsWithoutSorting({
  list,
  lists
}));
exports.updateListInLists = updateListInLists;
/**
 * Updates lists in the lists array and sorts the lists.
 */
const updateListsInLists = ({
  updatedLists,
  lists
}) => updatedLists.length > 0 ? (0, _sortLists.sortLists)(updatedLists.reduce((acc, list) => updateListInListsWithoutSorting({
  list,
  lists: acc
}), lists)) : lists;
exports.updateListsInLists = updateListsInLists;
